/* eslint-disable max-len */
import React from 'react';
import styled, {css, keyframes} from 'styled-components';

const clickAnimation = keyframes`
    0 {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
`;

const Container = styled.button`
    display: flex;
    width: ${props => props.width || 'auto'};
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: ${props =>
        props.background
            ? props.background
            : props.secondary
            ? '#211921'
            : '#000'};
    ${props => props.background && `background: ${props.background};`};
    border-radius: ${props =>
        props.dkids ? '25px' : props.secondary ? '4px' : '0.5rem'};
    border: 0;
    min-height: auto;
    padding: ${props => (props.cnito ? `20px 28px 20px` : `16px 28px 16px`)} ;
    ${props => props.margin && `margin: ${props.margin}`};
    color: ${props => (props.color ? props.color : '#fff')};
    font-family: ${props =>
        props.cnito
            ? 'Rodger'
            : props.dkids
            ? 'Dkids'
            : 'TTNormsProExtraBlack'};
    ${props =>
        props.cnito &&
        css`
            font-weight: bold;
        `};
    font-size: ${({dkids}) => (dkids ? 12 : 18)}px;
    line-height: 20px;
    text-transform: uppercase;
    transition: all 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);
    &:active,
    &:focus {
        animation: ${clickAnimation} 0.25s linear;
    }
    ${props => props.margin && `margin: ${props.margin}`};
    ${props =>
        props.small &&
        `
        height: 32px;
        font-size: 1rem;
        border-radius: 0.25rem;
    `}
    ${props =>
        props.medium &&
        `
        min-width: 132px;
        padding: 8px 18px 8px;
        font-size: 18px;
        line-height: 18px;
        border-radius: 0.5rem;
    `}
    ${props =>
        props.large &&
        `
        border-radius: 16px;
        padding: 15px 34px;
        font-size: 30px;
        line-height: 36px;
    `}
    ${props =>
        props.light &&
        `
        color: #080008;
        background-color: #fff;
    `}
    ${props =>
        props.disabled &&
        `
        opacity: 0.65 !important;
        pointer-events: none !important;
    `}

    @media screen and (max-width: 335px) {
        font-size: 5vw !important;
    }
`;

const Button = ({onClick, value, variant, children, ...props}) => {
    const handleMac = () => {
        return navigator.userAgent.indexOf('Mac OS X') !== -1;
    };

    return (
        <Container mac={handleMac()} {...props} onClick={onClick}>
            {value || children}
        </Container>
    );
};

export default Button;
